import { useEffect, useState } from "react";
import styles from "./ObservationButton.module.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import observationsService from "../../services/observations.service";

interface Props {
    ticketNumber: string;
    to?: string | undefined;
    canViewObservations?: boolean;
    openNewTab?: boolean;
}

const ObservationButton: React.FC<Props> = ({ ticketNumber, to, canViewObservations, openNewTab }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [totalObservations, setTotalObservations] = useState<number>(0);
    const [newTab, setNewTab] = useState("");

    const refreshObservations = () => {
        observationsService.countObservations(ticketNumber).then((count) => {
            setTotalObservations(count);
        });

        if (openNewTab) {
            setNewTab("_blank");
        }
    };

    useEffect(() => {
        refreshObservations();
      }, []);

    return canViewObservations ?
    (
        to ? (
            <Link className={styles.link} to={to} target={openNewTab ? newTab : ""}>
                <div className={styles.text}>{t("observationsKnowledgeBoard")}</div>
                <div className={styles.badgeColor}>{totalObservations}</div>
            </Link>
        ) : (
            <Link
                className={styles.link}
                onClick={(e) => {
                    e.preventDefault();
                    navigate(-1);
                }}
                to={".."}
            >
                <div className={styles.text}>{t("observationsKnowledgeBoard")}</div>
                <div className={styles.badgeColor}>{totalObservations}</div>
            </Link>
        )
    ) : (
        <></>
    );
};

export default ObservationButton;
